import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../common/Breadcrumb/Breadcrumb';
import MainScreenHeader from '../../common/Header/MainScreenHeader';
import '../../common/Breadcrumb/Breadcrumb.scss';
import { TeamDataProvider, Team } from '../../../data/TeamDataProvider';
import { FaArrowLeft } from 'react-icons/fa';
import './TeamDetails.scss';
import GenericVerticalTabs, { TabConfig } from '../../common/GenericVerticalTabs/GenericVerticalTabs';
import TeamGeneral from './TeamGeneral';
import TeamPeople from './TeamPeople';
import { UserRoles } from '../../../constants/UserRoles';

const TeamDetails: React.FC = () => {
  const { t } = useTranslation(['common', 'screens']);
  const { id } = useParams();
  const navigate = useNavigate();
  const teamId = id as string;
  const [team, setTeam] = useState<Team | null>(null);
  const provider = React.useMemo(() => new TeamDataProvider(), []);

  useEffect(() => {
    provider.getById(teamId).then(setTeam);
  }, [teamId]);

  const handleEdit = async (data: Partial<Team>) => {
    if (!team) return;
    const updated: Team = {
      ...team,
      ...data,
      name: data.name ?? team.name,
      description: data.description ?? team.description,
    };
    await provider.update(updated.id!, updated);
    setTeam(updated);
  };

  if (!team) return <div>{t('common:loading')}</div>;

  const tabs: TabConfig[] = [
    {
      key: 'general',
      label: t('screens:teams.tabs.general'),
      content: <TeamGeneral team={team} onEdit={handleEdit} />,
    },
    {
      key: 'people',
      label: t('screens:teams.tabs.people'),
      content: <TeamPeople teamId={team.id!} />,
      allowedRoles: UserRoles.Admin + ',' + UserRoles.Manager,
    }
  ];

  return (
    <div className="team-details-page">
      <Breadcrumb
        items={[
          { label: t('screens:teams.title'), onClick: () => navigate('/teams') },
          { label: team.name }
        ]}
      />
      <MainScreenHeader title={team.name}/>
      <GenericVerticalTabs tabs={tabs} initialTabKey="general" />

    </div>
  );
};

export default TeamDetails;
